import config from '../config';

/**
 * Pages vitrine (monlivresms-www) utiles depuis l'app : légal, FAQ, contact.
 * Slugs / titres alignés sur les page.yaml de content/pages de la vitrine.
 */
export const WEBSITE_PAGES = {
    terms: {
        slugs: {
            fr: 'conditions-generales-de-vente',
            en: 'terms-and-conditions-of-sale',
            es: 'condiciones-generales-de-venta',
            it: 'termini-e-condizioni-di-vendita',
            pt: 'termos-e-condicoes-de-venda',
            nl: 'algemene-verkoopvoorwaarden',
            de: 'allgemeine-geschaeftsbedingungen',
            ko: 'terms-of-sale',
            ja: 'terms-of-sale',
        },
        titles: {
            fr: 'CGV',
            en: 'Terms of sale',
            es: 'Condiciones de venta',
            it: 'Condizioni di vendita',
            pt: 'Condições de venda',
            nl: 'Verkoopvoorwaarden',
            de: 'AGB',
            ko: '판매 약관',
            ja: '販売規約',
        },
    },
    legal: {
        slugs: {
            fr: 'mentions-legales',
            en: 'legal-mentions',
            es: 'aviso-legal',
            it: 'note-legali',
            pt: 'aviso-legal',
            nl: 'wettelijke-vermeldingen',
            de: 'impressum',
            ko: 'legal-notice',
            ja: 'legal-notice',
        },
        titles: {
            fr: 'Mentions légales',
            en: 'Legal mentions',
            es: 'Aviso legal',
            it: 'Note legali',
            pt: 'Aviso legal',
            nl: 'Wettelijke vermeldingen',
            de: 'Impressum',
            ko: '법적 고지',
            ja: '法的表記',
        },
    },
    faq: {
        slugs: {
            fr: 'comment-imprimer-ses-messages-smartphone',
            en: 'how-to-print-your-messages-from-a-smartphone',
            es: 'preguntas-frecuentes',
            it: 'domande-frequenti',
            pt: 'perguntas-frequentes',
            nl: 'veelgestelde-vragen',
            de: 'haeufige-fragen',
            ko: 'faq',
            ja: 'faq',
        },
        titles: {
            fr: 'FAQ',
            en: 'FAQ',
            es: 'FAQ',
            it: 'FAQ',
            pt: 'FAQ',
            nl: 'FAQ',
            de: 'FAQ',
            ko: '자주 묻는 질문',
            ja: 'よくある質問',
        },
    },
    contact: {
        slugs: {
            fr: 'contact',
            en: 'contact',
            es: 'contacto',
            it: 'contatto',
            pt: 'contacto',
            nl: 'contact',
            de: 'kontakt',
            ko: 'contact',
            ja: 'contact',
        },
        titles: {
            fr: 'Contact',
            en: 'Contact',
            es: 'Contacto',
            it: 'Contatto',
            pt: 'Contacto',
            nl: 'Contact',
            de: 'Kontakt',
            ko: '문의',
            ja: 'お問い合わせ',
        },
    },
};

export const LANGUAGE_NATIVE_LABELS = {
    fr: 'Français',
    en: 'English',
    es: 'Español',
    it: 'Italiano',
    pt: 'Português',
    nl: 'Nederlands',
    de: 'Deutsch',
    ko: '한국어',
    ja: '日本語',
};

const COOKIE_LABELS = {
    fr: 'Cookies',
    en: 'Cookies',
    es: 'Cookies',
    it: 'Cookies',
    pt: 'Cookies',
    nl: 'Cookies',
    de: 'Cookies',
    ko: '쿠키 설정',
    ja: 'Cookie設定',
};

const LANGUAGE_PREFERENCE_UPDATED = {
    fr: 'Langue enregistrée sur votre compte. Les prochains livres seront générés dans cette langue.',
    en: 'Language saved to your account. Your next books will be generated in this language.',
    es: 'Idioma guardado en tu cuenta. Tus próximos libros se generarán en este idioma.',
    it: 'Lingua salvata sul tuo account. I prossimi libri saranno generati in questa lingua.',
    pt: 'Idioma guardado na sua conta. Os próximos livros serão gerados neste idioma.',
    nl: 'Taal opgeslagen op je account. Je volgende boeken worden in deze taal gegenereerd.',
    de: 'Sprache in deinem Konto gespeichert. Deine nächsten Bücher werden in dieser Sprache erstellt.',
    ko: '계정에 언어가 저장되었습니다. 앞으로 만들어지는 책은 이 언어로 생성됩니다.',
    ja: 'アカウントに言語を保存しました。これから作る本はこの言語で生成されます。',
};

function resolveLang(lang) {
    return WEBSITE_PAGES.terms.slugs[lang] ? lang : 'en';
}

export function getWebsitePageUrl(pageId, lang) {
    const page = WEBSITE_PAGES[pageId];
    if(!page) {
        return config.website.url;
    }
    const resolved = resolveLang(lang);
    const slug = page.slugs[resolved] || page.slugs.en;
    return `${config.website.url}/${resolved}/${slug}/`;
}

export function getWebsitePageTitle(pageId, lang) {
    const page = WEBSITE_PAGES[pageId];
    if(!page) {
        return '';
    }
    const resolved = resolveLang(lang);
    return page.titles[resolved] || page.titles.en || '';
}

export function getCookieManageLabel(lang) {
    const resolved = resolveLang(lang);
    return COOKIE_LABELS[resolved] || COOKIE_LABELS.en;
}

export function getLanguagePreferenceUpdatedMessage(lang) {
    const resolved = resolveLang(lang);
    return LANGUAGE_PREFERENCE_UPDATED[resolved] || LANGUAGE_PREFERENCE_UPDATED.en;
}
